// @flow

export const FIELD_TYPE_DATE: 'date' = 'date';
export const FIELD_TYPE_ENUM: 'enum' = 'enum';
export const FIELD_TYPE_INTEGER: 'integer' = 'integer';
export const FIELD_TYPE_FLOAT: 'float' = 'float';
export const FIELD_TYPE_MULTISELECT: 'multiSelect' = 'multiSelect';
export const FIELD_TYPE_STRING: 'string' = 'string';
export const FIELD_TYPE_TAXONOMY: 'taxonomy' = 'taxonomy';
